import { getContrastYIQ } from '@app/utils';

export interface StageColors {
  background: string;
  text: string;
}

const HEX_FULL_REGEXP = /^#?([0-9a-fA-F]{6})$/;
const HEX_SHORT_REGEXP = /^#?([0-9a-fA-F]{3})$/;

const NEUTRAL_BACKGROUND = '#f0f2f5';
const NEUTRAL_TEXT = 'rgba(0, 0, 0, 0.88)';

const normalizeHexColor = (color: string | null | undefined): string | null => {
  if (!color) return null;

  const value = color.trim();

  const fullMatch = HEX_FULL_REGEXP.exec(value);
  if (fullMatch) return `#${fullMatch[1].toLowerCase()}`;

  const shortMatch = HEX_SHORT_REGEXP.exec(value);
  if (shortMatch) {
    const [r, g, b] = shortMatch[1].toLowerCase().split('');
    return `#${r}${r}${g}${g}${b}${b}`;
  }

  return null;
};

export const getStageColors = (
  color: string | null | undefined
): StageColors => {
  const hex = normalizeHexColor(color);

  if (!hex) {
    return { background: NEUTRAL_BACKGROUND, text: NEUTRAL_TEXT };
  }

  return { background: hex, text: getContrastYIQ(hex) };
};
